import type { Network } from "../types";

export const skype: Network = {
  name: "Skype",
  shareUrl: "https://web.skype.com/share?url=[u]",
  args: {
    title: "&text=[t]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#00AFF0",
};
